import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import t from "./Accessor.js";
import { read as s } from "./accessorSupport/read.js";
import { write as e } from "./accessorSupport/write.js";
import { subclass as o } from "./accessorSupport/decorators/subclass.js";

var i = function i(t) {
  var i = /*#__PURE__*/function (_t) {
    _inherits(i, _t);

    var _super = _createSuper(i);

    function i() {
      _classCallCheck(this, i);

      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }

      return _super.call.apply(_super, [this].concat(r));
    }

    _createClass(i, [{
      key: "read",
      value: function read(r, t) {
        s(this, r, t);
      }
    }, {
      key: "write",
      value: function write() {
        var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = arguments.length > 1 ? arguments[1] : undefined;
        return e(this, r, t);
      }
    }, {
      key: "toJSON",
      value: function toJSON(r) {
        return this.write({}, r);
      }
    }], [{
      key: "fromJSON",
      value: function fromJSON(r, t) {
        return c.call(this, r, t);
      }
    }]);

    return i;
  }(t);

  return i = r([o("esri.core.JSONSupport")], i), i.prototype.toJSON.isDefaultToJSON = !0, i;
};

function c(r, t) {
  if (!r) return null;
  if (r.declaredClass) throw new Error("JSON object is already hydrated");
  var s = new this();
  return s.read(r, t), s;
}

function n(r) {
  return r && "read" in r && "write" in r && "toJSON" in r;
}

var a = /*#__PURE__*/function (_i) {
  _inherits(a, _i);

  var _super2 = _createSuper(a);

  function a() {
    _classCallCheck(this, a);

    return _super2.apply(this, arguments);
  }

  return a;
}(i(t));

a = r([o("esri.core.JSONSupport")], a);
export { a as JSONSupport, i as JSONSupportMixin, n as isJSONSupport };